import React, { useEffect, useState, useRef } from "react";
import { CAPTURETYPE } from "../pages/MobileVerificationLandingPage";
import "./IDCapture.css";
import ImageReview from "./ImageReview";

const IDCapture = ({ uploadInProgress, captureType, changePage, onImageCapture }) => {
  const fileInputRef = useRef(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [review, setReview] = useState(false)

  useEffect(() => {
    setReview(false);
    setSelectedFile(null);
  }, [captureType])

  const uploadImage = () => {
    fileInputRef.current.click();
  };

  const onImageUploaded = (onImageCapture) => {
    if (selectedFile) {
      onImageCapture(selectedFile);
    }
  };

  const handleBackButton = () => {
    if (review) {
      setReview(false);
      setSelectedFile(null);
    } else {
      changePage(captureType - 1)
    }
  }

  const headerItem = (prompt) => (
    <section className="container">
      <div className="row py-3">
        <div className="mx-auto text-center">
          <button type="button"
            className="verification-button-back"
            onClick={handleBackButton}
          >
            <img src={require("../assets/img/chevron-left.svg").default}/>
          </button>
          <h1 className="py-2">Verify</h1>
          <div className="fs-4">
           {prompt}
          </div>
        </div>
      </div>
    </section>
  )

  const bodyItem = (image, prompt) => (
      <div className="container py-3">
        <div className="row">
          <div className="col">
            <div className="verification-item-container single card-body bg-white shadow-sm">
              <img 
                className="verification-item-img" 
                style={{width: "75px"}}
                src={image} 
              />
            </div>
            <div className="text-center pt-2 fs-3">
              {prompt}
            </div>
          </div>
        </div>
    </div>
  );

  const mainContent = (captureType) => {
    let image = null
    let prompt = null
    switch (captureType) {
      case CAPTURETYPE.IDFront:
        image = require("../assets/img/drivers-license-front.svg").default;
        prompt = "Take a picture of the front side of your ID or upload it from the camera roll on your phone"
        return (
          <>
            {headerItem(prompt)}
            <div className="album bg-light">
              {bodyItem(image, "ID - Front Side")}
            </div>
          </>
        )
      case CAPTURETYPE.IDBack:
        image = require("../assets/img/drivers-license-back.svg").default
        prompt = "Take a picture of the back side of your ID or upload it from the camera roll on your phone"
        return (
          <>
            {headerItem(prompt)}
            <div className="album bg-light">
              {bodyItem(image, "ID - Back Side")}
            </div>
          </>
        )
      case CAPTURETYPE.Selfie:
        image = require("../assets/img/camera.svg").default
        prompt = "Take a selfie: use good lighting and center your head inside the frame"
        return (
          <>
            {headerItem(prompt)}
            <div className="album bg-light">
              {bodyItem(image, "Selfie")}
            </div>
          </>
        )
      default:
        return (
          <>
            <section className="container">
              <div className="row py-lg-5 py-3">
                <div className="mx-auto">
                  <h1 className="d-flex justify-content-center">ERROR</h1>
                  <p className="lead d-flex justify-content-center text-center">
                    ERROR
                  </p>
                </div>
              </div>
            </section>
            <div className="album bg-light">
              <div>ERROR</div>
            </div>
          </>
        );
    }
  };

  if (review || uploadInProgress) {
    return <ImageReview 
      file={selectedFile}
      selectFile={(file) => setSelectedFile(file)}
      onImageUploaded={() => onImageUploaded(onImageCapture)}
      backButton={() => handleBackButton()}
    />
  } else {
    return (
      <>
        {mainContent(captureType)}
        <div className="py-3">
          <div className="span2 d-flex justify-content-center py-2">
            <button
              className="btn btn-block verification-button-auth"
              onClick={uploadImage}
            >
              <span className="text-uppercase pb-1 fs-5">Take Photo</span>
            </button>
            <input
              type="file"
              id="files"
              ref={fileInputRef}
              accept=".jpg,.png,.jpeg,.bmp,.gif,image/jpg,image/gif,image/png,image/bmp"
              multiple=""
              style={{ display: "none" }}
              onChange={() => {
                setSelectedFile(fileInputRef.current.files[0]);
                setReview(true);
              }}
            />
          </div>
        </div>
      </>
    )
  }
};

export default IDCapture;
